import { createModel } from "hox";
import { httpRequest } from './HttpRequest'
import { useSessionStorageState } from "ahooks";

export interface IRoleColumn {
    "roleCode"?: string,
    "code"?: string,
    "userId"?: string,
    "val"?: string,
    "remark"?: string,
    "id"?: string,
    "model"?: string,
}

export interface IRoleColumnDetail {
    id?: string,
    model?: string,
    type?: string,
    showable?: string,
    name?: string,
    code?: string,
    editable?: string,
}

export const roleColumnModel = createModel(function () {

    const [roleColumns, setRoleColumns] = useSessionStorageState<IRoleColumn[]>("roleColumns", []);

    const queryRoleColumns = async (params?: any) => {
        //根据code和roleCodes查询可视化配置(可能有不同角色重复配置情况)
        const url = "/zzw-portal/auth/column/list";
        const { retData } = await httpRequest.post<IRoleColumn[]>(url, params);
        setRoleColumns(retData)
    }

    const getRoleColumns = (code: string, type: string, columns: any[], params?: any) => {
        const cols = roleColumns.filter(e => e.code === code);

        //val合并数组
        let array: IRoleColumnDetail[] = [];
        for (let item of cols) {
            const list: IRoleColumnDetail[] = JSON.parse(item.val ?? "");
            const newList = list.map(e => ({ ...e, id: ((e.model ?? "") + e.name + e.code + e.type) }));
            array = array.concat(newList);
        }
        array = array.filter(e => e.type === type);

        //数组去重，并取将重复数据中showable、editable的原0含1情况优先为1
        const newArray = array.reduce((accumulator: IRoleColumnDetail[], current, currentIndex) => {
            const duplicate = accumulator.find(item => item.id === current.id);
            if (!duplicate) {
                return accumulator.concat([current]);
            }
            else {
                const idx = accumulator.findIndex(item => item.id === current.id);
                if (idx != currentIndex && duplicate.showable === "0" && current.showable === "1") {
                    accumulator[idx] = { ...accumulator[idx], showable: "1" };
                }
                if (idx != currentIndex && duplicate.editable === "0" && current.editable === "1") {
                    accumulator[idx] = { ...accumulator[idx], editable: "1" };
                }
                return accumulator;
            }
        }, []);

        //根据可视化配置，删除不展示的列
        for (let i = columns.length - 1; i >= 0; i--) {
            const item = newArray.find(e => e.code === columns[i].dataIndex);
            if (item != undefined && item.showable === "0") {
                columns.splice(i, 1);
            }
        }

        //根据可视化配置，处理是否编辑项目
        for (var i = 0; i < columns.length; i++) {
            const item = newArray.find(e => e.code === columns[i].dataIndex);
            if (item != undefined && item.editable === "0") {
                columns[i] = {
                    ...columns[i],
                    onCell: () => {
                        return {
                            ...columns[i]?.onCell,
                            editable: false
                        }
                    }
                }
            }
        }

        return columns
    }

    const getHideRoleColumns = (code: string, type: string) => {
        const cols = roleColumns.filter(e => e.code === code);

        //val合并数组
        let array: IRoleColumnDetail[] = [];
        for (let item of cols) {
            const list: IRoleColumnDetail[] = JSON.parse(item.val ?? "");
            const newList = list.map(e => ({ ...e, id: ((e.model ?? "") + e.name + e.code + e.type) }));
            array = array.concat(newList);
        }
        array = array.filter(e => e.type === type);

        //数组去重，并取将重复数据中showable、editable的原0含1情况优先为1
        const newArray = array.reduce((accumulator: IRoleColumnDetail[], current, currentIndex) => {
            const duplicate = accumulator.find(item => item.id === current.id);
            if (!duplicate) {
                return accumulator.concat([current]);
            }
            else {
                const idx = accumulator.findIndex(item => item.id === current.id);
                if (idx != currentIndex && duplicate.showable === "0" && current.showable === "1") {
                    accumulator[idx] = { ...accumulator[idx], showable: "1" };
                }
                if (idx != currentIndex && duplicate.editable === "0" && current.editable === "1") {
                    accumulator[idx] = { ...accumulator[idx], editable: "1" };
                }
                return accumulator;
            }
        }, []);

        return newArray.filter(e => e.showable === "0").map(e => e.code);
    }

    return {
        roleColumns,
        queryRoleColumns,
        getRoleColumns,
        getHideRoleColumns,
    }
});